import { AppQueryStringOptions } from "@/Common/Api/ApiSettings";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { FileType } from "@/Common/Models/FileType";

/**
 * The options that can be passed to `FileSelectionHelper.getFetchUrl`.
 */
type GetFetchUrlOptions = AppQueryStringOptions;

class FileSelectionHelper {
    /**
     * Get a relative URL to render or download a file.
     * @param id The file ID.
     * @param type The file type.
     * @param options The settings which customize the URL.
     */
    public static getFetchUrl(id: string, type: FileType, options: GetFetchUrlOptions = null, signedPrintAuthId: string | null = null): string {
        if (IsNullOrWhiteSpace(id))
            return "";

        const signPrintUrlSection = signedPrintAuthId
            ? `/${signedPrintAuthId}`
            : "";
        let route = "";
        switch (type) {
            case FileType.ATTACHMENT:
                route = `api/attachments/download/${id}`;
                break;
            case FileType.DOCUMENT:
                // Broken. We can't pass a DocumentId because it may represent multiple different Pdfs. Its currently used but its passing the documentByteId
                route = `api/medicalDocuments/downloadFile/${id}`;
                break;
            case FileType.DOCUMENTBYTES:
                route = `api/medicalDocuments/downloadFile/${id}`;
                break;
            case FileType.LABPDF:
                route = `api/labs/downloadFile/${id}`;
                break;
            case FileType.ENCOUNTER:
                route = `api/pdf/fetchNote/${id}`;
                break;
            case FileType.MEDICALSUMMARY:
                route = `api/pdf/fetchMedicalSummary/${id}`;
                break;
            case FileType.MEDICATIONSUMMARY:
                route = `api/pdf/fetchMedicationSummary/${id}`;
                break;
            case FileType.HEIGHTGRAPH:
                route = `api/pdf/fetchHeightGrowthCurves/${id}`;
                break;
            case FileType.LENGTHGRAPH:
                route = `api/pdf/fetchLengthGrowthCurves/${id}`;
                break;
            case FileType.WEIGHTGRAPH0TO2:
                route = `api/pdf/fetchWeight0To2GrowthCurves/${id}`;
                break;
            case FileType.WEIGHTGRAPH2PLUS:
                route = `api/pdf/fetchWeight2PlusGrowthCurves/${id}`;
                break;
            case FileType.BMIGRAPH:
                route = `api/pdf/fetchBMIGrowthCurves/${id}`;
                break;
            case FileType.HEADCIRCUMFERENCEGRAPH:
                route = `api/pdf/fetchHeadCircumferenceGrowthCurves/${id}`;
                break;
            case FileType.RADPDF:
                route = `api/pdf/fetchRadpdfForm/${id}${signPrintUrlSection ? `/${GuidHelper.Empty}/${signPrintUrlSection}` : ""}`;
                break;
            case FileType.EXAMREQUEST:
                route = `api/pdf/fetchExamRequest/${id}/true${signPrintUrlSection}`;
                break;
            case FileType.CONSULTATIONREQUEST:
                route = `api/pdf/fetchConsultationRequest/${id}/true${signPrintUrlSection}`;
                break;
            case FileType.TemporaryFileForClinicians:
            case FileType.TemporaryFile:
                route = `api/pdf/fetch/${id}`;
                break;
            case FileType.WORKERCLAIM:
                route = `api/pdf/fetchSentCnesstForm/${id}`;
                break;
            case FileType.OBSTETRICALFILE:
                route = `api/pdf/fetchObstetricalFile/${id}`;
                break;
            case FileType.PatientGrowthChart:
                route = `api/pdf/fetchPatientGrowthChart/${id}`;
                break;
            case FileType.BatchScan:
                route = `api/pdf/fetchBatchScan/${id}`;
                break;
            case FileType.WorkSafeBcForm:
                route = `api/pdf/fetch/${id}`;
                break;
            case FileType.Invoice:
                route = `api/pdf/fetchPrivateBill/${id}`;
                break;
            case FileType.ImmunizationReport:
                route = `api/pdf/fetch/${id}`;
                break;
        }

        if (route) {
            options ??= {};
            options.auth = options.auth !== false; // authenticate by default

            route += apiSettings.buildQueryString(options);
        }

        return route;
    }

    public static getFetchUrlXcom(clientTag: string, claimId: string, id: string, type: FileType, options: GetFetchUrlOptions = null, signedPrintAuthId: string | null = null): string {
        if (IsNullOrWhiteSpace(id))
            return "";

        const signPrintUrlSection = signedPrintAuthId
            ? `/${signedPrintAuthId}`
            : "";
        let route = "";
        switch (type) {
            case FileType.ATTACHMENT:
                route = `api/attachments/download/${id}`;
                break;
            case FileType.DOCUMENT:
                // Broken. We can't pass a DocumentId because it may represent multiple different Pdfs. Its currently used but its passing the documentByteId
                route = `api/medicalDocuments/downloadFile/${id}`;
                break;
            case FileType.DOCUMENTBYTES:
                route = `api/medicalDocuments/downloadFile/${id}`;
                break;
            case FileType.LABPDF:
                route = `api/labs/downloadFile/${id}`;
                break;
            case FileType.ENCOUNTER:
                route = `api/pdf/fetchNote/${id}`;
                break;
            case FileType.MEDICALSUMMARY:
                route = `api/pdf/fetchMedicalSummary/${id}`;
                break;
            case FileType.MEDICATIONSUMMARY:
                route = `api/pdf/fetchMedicationSummary/${id}`;
                break;
            case FileType.HEIGHTGRAPH:
                route = `api/pdf/fetchHeightGrowthCurves/${id}`;
                break;
            case FileType.LENGTHGRAPH:
                route = `api/pdf/fetchLengthGrowthCurves/${id}`;
                break;
            case FileType.WEIGHTGRAPH0TO2:
                route = `api/pdf/fetchWeight0To2GrowthCurves/${id}`;
                break;
            case FileType.WEIGHTGRAPH2PLUS:
                route = `api/pdf/fetchWeight2PlusGrowthCurves/${id}`;
                break;
            case FileType.BMIGRAPH:
                route = `api/pdf/fetchBMIGrowthCurves/${id}`;
                break;
            case FileType.HEADCIRCUMFERENCEGRAPH:
                route = `api/pdf/fetchHeadCircumferenceGrowthCurves/${id}`;
                break;
            case FileType.RADPDF:
                route = `api/pdf/fetchRadpdfForm/${id}${signPrintUrlSection ? `/${GuidHelper.Empty}/${signPrintUrlSection}` : ""}`;
                break;
            case FileType.EXAMREQUEST:
                route = `api/pdf/fetchExamRequest/${id}/true${signPrintUrlSection}`;
                break;
            case FileType.CONSULTATIONREQUEST:
                route = `api/pdf/fetchConsultationRequest/${id}/true${signPrintUrlSection}`;
                break;
            case FileType.TemporaryFileForClinicians:
            case FileType.TemporaryFile:
                route = `api/pdf/fetch/${id}`;
                break;
            case FileType.WORKERCLAIM:
                route = `api/pdf/fetchSentCnesstForm/${id}`;
                break;
            case FileType.OBSTETRICALFILE:
                route = `api/pdf/fetchObstetricalFile/${id}`;
                break;
            case FileType.PatientGrowthChart:
                route = `api/pdf/fetchPatientGrowthChart/${id}`;
                break;
            case FileType.BatchScan:
                route = `api/pdf/fetchBatchScan/${id}`;
                break;
            case FileType.WorkSafeBcForm:
                route = `api/pdf/fetch/${id}`;
                break;
            case FileType.Invoice:
                route = `api/pdf/fetchPrivateBill/${id}`;
                break;
            case FileType.ImmunizationReport:
                route = `api/pdf/fetch/${id}`;
                break;
        }

        if (route) {
            options ??= {};
            options.auth = options.auth !== false; // authenticate by default

            route += apiSettings.buildQueryString(options);
        }

        return `api/xcom/${clientTag}/${claimId}/${route}`;
    }

    public static determineTypeName(type: FileType): string {
        let typeName: string = "";
        switch (type) {
            case FileType.ATTACHMENT:
            case FileType.DOCUMENT:
                typeName = cacheStore.GetString("DocumentsLabel");
                break;
            case FileType.LAB:
            case FileType.LABPDF:
                typeName = cacheStore.GetString("LaboratoryLabel");
                break;
            case FileType.ENCOUNTER:
                typeName = cacheStore.GetString("ClinicalNoteLabel");
                break;

            case FileType.MEDICALSUMMARY:
            case FileType.MEDICATIONSUMMARY:
                typeName = cacheStore.GetString("SummaryLabel");
                break;

            case FileType.HEIGHTGRAPH:
            case FileType.LENGTHGRAPH:
            case FileType.WEIGHTGRAPH0TO2:
            case FileType.WEIGHTGRAPH2PLUS:
            case FileType.BMIGRAPH:
            case FileType.HEADCIRCUMFERENCEGRAPH:
            case FileType.PatientGrowthChart:
                typeName = cacheStore.GetString("GraphiqueShortlbl");
                break;

            case FileType.WORKERCLAIM:
            case FileType.RADPDF:
            case FileType.OBSTETRICALFILE:
                typeName = cacheStore.GetString("FormLabel");
                break;

            case FileType.EXAMREQUEST:
                typeName = cacheStore.GetString("ExamRequestLabel");
                break;

            case FileType.CONSULTATIONREQUEST:
                typeName = cacheStore.GetString("ConsultationRequestLabel");
                break;

            case FileType.Invoice:
                typeName = cacheStore.GetString("InvoicesLabel");
                break;

            case FileType.ImmunizationReport:
                typeName = cacheStore.GetString("ImmunizationLabel");
                break;

            default:
                typeName = FileType[type];
                break;
        }

        return typeName;
    }
}

export { FileSelectionHelper, GetFetchUrlOptions };
